import Joi from "joi";
import { emailRegex, panRegex, tanRegex } from "../../../../utils/common";



export const OrgSchema = Joi.object({
    org_name: Joi.string()
        .min(3)
        .max(255)
        .required()
        .messages({
            "string.empty": "Organization name is required.",
            "string.min": "Organization name must be at least 3 characters.",
            "string.max": "Organization name must not exceed 255 characters.",
            "any.required": "Organization name is required.",
        }),

    landline: Joi.string()
        .allow(null, "")
        .custom((value, helpers) => {
            const trimmedValue = value.toString().trim();
            if (trimmedValue !== "" && !/^\d{11}$/.test(trimmedValue)) {
                return helpers.error("any.invalid");
            }
            return trimmedValue;
        })
        .messages({
            "any.invalid": "Invalid Landline number format.",
        }),

    phone: Joi.number()
        .integer()
        .required()
        .custom((value, helpers) => {
            const trimmedValue = value.toString().trim();
            if (trimmedValue === "") {
                return helpers.error("any.required");
            } else {
                if (!/^[6-9][0-9]{9}$/.test(trimmedValue)) {
                    return helpers.error("any.invalid");
                }
            }
            return Number(trimmedValue);
        })
        .messages({
            "any.required": "Phone number is required.",
            "number.empty": "Phone number is required.",

            "number.base": "Phone number is required.",
            "any.invalid": "Invalid phone number format.",
        }),

    email: Joi.string().pattern(emailRegex).email({ tlds: { allow: false } }).required().messages({
        "string.pattern.base": "Invalid  email format",
        "string.base": "Email is required.",
        "string.required": "Email is required.",
        "string.invalid": "Email is required.",
        "string.empty": "Email is required.",
        "string.email": "Please provide a valid email address.",
    }),

    domain_name: Joi.string()
        .min(3)
        .max(50)
        .required()
        .messages({
            "string.empty": "Domain name is required.",
            "any.invalid": "Domain name is required.",
            "string.min": "Domain name must be at least 3 characters.",
            "string.max": "Domain name must not exceed 50 characters.",
            "any.required": "Domain name is required.",
            "string.base": "Domain name is required.",
        }),

    tan_no: Joi.string()
        .pattern(tanRegex)
        .length(10)
        .allow(null, "")
        .messages({
            "string.empty": "TAN number cannot be empty.",
            "string.pattern.base": "TAN number must follow the format ABCD12345K.",
            "string.length": "TAN number must be exactly 10 characters long.",
            "any.required": "TAN number is a required field.",
            "any.invalid": "Invalid TAN number format.",
        }),

    pan: Joi.string()
        .allow(null, "")
        .pattern(panRegex)
        .messages({
            "string.empty": "PAN number is required.",
            "string.pattern.base": "PAN number must be in the format ABCTY1234D.",
            "any.required": "PAN is required.",
            "any.invalid": "Invalid PAN number format.",
        }),

    industry_type: Joi.string()
        .allow(null, "")
        .messages({
            "string.empty": "Industry type is required.",
            "any.required": "Industry type is required.",
        }),

    registration_type: Joi.string()
        .min(2)
        .max(100)
        .required()
        .messages({
            "string.empty": "Organization Category is required.",
            "any.required": "Organization Category is required.",
            "string.min": "Organization Category must be at least 2 characters.",
            "string.max": "Organization Category must not exceed 100 characters.",
            "string.base": "Organization Category is required.",
        }),

    // domain_authorization: Joi.number()
    //     .integer()
    //     .required()
    //     .messages({
    //         "number.base": "Domain authorization must be a number.",
    //         "any.required": "Domain authorization is required.",
    //     }),
    date_of_org: Joi.date()
        .allow(null, "")
        .messages({
            "date.base": "Invalid date format.",
            "any.required": "Date of organization is required.",
        }),

    payment_type: Joi.string()
        .min(2)
        .max(100)
        .required()
        .empty('')
        .messages({
            "string.min": "Payment type must be at least 2 characters.",
            "string.max": "Payment type must not exceed 100 characters.",
            "any.required": "Payment type is required.",
            "string.base": "Payment type is required.",
            "string.empty": "Payment type cannot be empty.",
        }),
    // wages_type: Joi.string()
    //     .required().messages({



    //         "string.empty": "Salary type is required.",
    //         "any.invalid": "Salary type is required.",

    //         "any.required": "Salary type is required.",
    //     }),
    //   wages_days: Joi.string()
    // .required().messages({



    //     "string.empty": "wages days is required.",
    //     "any.invalid": "wages days is required.",

    //     "any.required": "wages days is required.",
    //   }),

    address: Joi.string()
        .min(5)
        .max(500)
        .allow(null, "")
        .messages({
            "string.empty": "Address is required.",
            "any.required": "Address is required.",
            "any.invalid": "Address is required.",

            "string.min": "Address must be at least 5 characters.",
            "string.max": "Address must not exceed 500 characters.",
        }),

    locality: Joi.string()
        .min(2)
        .max(300)
        .allow(null, "")
        .messages({
            "string.empty": "Locality is required.",
            "any.required": "Locality is required.",
            "any.invalid": "Locality is required.",
            "string.min": "Locality must be at least 2 characters.",
            "string.max": "Locality must not exceed 300 characters.",
        }),

    city: Joi.string()
        .min(3)
        .max(300)
        .allow(null, "")
        .messages({
            "string.empty": "City is required.",
            "any.required": "City is required.",
            "any.invalid": "City is required.",
            "string.min": "City must be at least 3 characters.",
            "string.max": "City must not exceed 300 characters.",
        }),

    state: Joi.number()
        .integer()
        .allow(null, "")
        .messages({
            "number.base": "State must be a valid number.",
            "any.required": "State is required.",
        }),

    country: Joi.string()
        .min(3)
        .max(100)
        .allow(null, "")
        .messages({
            "string.min": "Country must be at least 3 characters.",
            "string.max": "Country must not exceed 100 characters.",
            "any.required": "Country is required.",
        }),

    pincode: Joi.string()
        .pattern(/^\d{6}$/)
        .allow(null, "")
        .messages({
            "string.empty": "Pincode is required.",
            "any.required": "Pincode is required.",
            "any.invalid": "Pincode is required.",
            "string.pattern.base": "Pincode must be exactly 6 digits.",
        }),

    landmark: Joi.string()
        .min(3)
        .max(300)
        .allow(null, "")
        .messages({
            "string.empty": "Landmark is required.",
            "any.required": "Landmark is required.",
            "any.invalid": "Landmark is required.",
            "string.min": "Landmark must be at least 3 characters.",
            "string.max": "Landmark must not exceed 300 characters.",
        }),

    first_name: Joi.string().min(3).max(50).required()
        .messages({
            "any.required": "First name is required.",
            "string.empty": "First name is required.",
            "string.min": "First name must be at least 3 characters.",
            "string.max": "First name must not exceed 255 characters.",
        }),

    last_name: Joi.string().min(2).max(50).required().messages({
        "any.required": "Last name is required.",
        "string.empty": "Last name is required.",
        "string.min": "Last name must be at least 3 characters.",
        "string.max": "Last name must not exceed 255 characters.",
    }),

    password: Joi.string()
        .min(8)
        .max(255)
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!]).*$/, 'password requirements')
        .optional()
        .messages({
            'string.pattern.name': 'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.',
        }),

    confirm_password: Joi.string()
        .required()
        .messages({
            'any.required': 'Confirm password is required.',
        }),
});

